export default __webpack_public_path__ + "static/media/arena_5.0e614524.jpeg";